import script from "./VoucherStatementUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherStatementUpload.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__